import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchLockerQty } from '../actions/objectives';
import LockerQtyFilterForm from '../forms/LockerQtyFilterForm';
import ErrorMessage from '../components/ErrorMessage';
import LoadingProgress from '../components/LoadingProgress';
import { formValueSelector } from 'redux-form';
import '../styles/LockerQtyView.css';

const selector = formValueSelector('LockerQtyFilterForm');

class LockerQtyView extends React.Component {

  componentDidMount() {
    const { role, customerId, fetchLockerQty } = this.props;
    const year = new Date().getFullYear().toString();
    const customer = role === 'ADMIN' ? undefined : customerId;
    fetchLockerQty(customer, year, undefined);
  }

  renderTable() {
    const { objectives, loading, error } = this.props.objectives;

    if (loading) return <LoadingProgress />;
    if (error) return <ErrorMessage message={error.message || error} />;
    if (!Array.isArray(objectives) || objectives.length === 0) {
      return <div className="lqty-no-data"><i className="fas fa-inbox mr-2"></i>No hay datos para los filtros seleccionados.</div>;
    }
    return (
      <table className="lqty-table">
        <thead>
          <tr>
            <th>Taquilla</th>
            <th>Ventas</th>
          </tr>
        </thead>
        <tbody>
          {objectives.map((row, idx) => (
            <tr key={idx}>
              <td>{row.Locker}</td>
              <td>{row.SalesCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderTotals() {
    const { machines, objectives: objectivesState, selectedCustomer, selectedMachine } = this.props;
    const { objectives, loading, error } = objectivesState;

    if (loading) return <LoadingProgress />;
    if (error) return null;
    if (!Array.isArray(objectives)) return null;

    const filteredMachines = Array.isArray(machines)
      ? machines.filter(m =>
          (!selectedCustomer || (m.Customer && m.Customer._id === selectedCustomer)) &&
          (!selectedMachine || m._id === selectedMachine)
        )
      : [];

    const totalLastIndex = filteredMachines.reduce((sum, m) => sum + (m.LastIndex || 0), 0);
    const salesData = objectives;
    const totalSales = salesData.reduce((sum, o) => sum + (o.SalesCount || 0), 0);
    const activeLockers = salesData.length;
    const idleLockers = Math.max(0, totalLastIndex - activeLockers);
    const avgSalesPerLocker = activeLockers ? (totalSales / activeLockers).toFixed(2) : '0.00';
    const utilizationRate = totalLastIndex ? ((activeLockers / totalLastIndex) * 100).toFixed(1) : '0.0';
    const topLocker = salesData.reduce((top, curr) =>
      !top || curr.SalesCount > top.SalesCount ? curr : top, null
    );

    const stats = [
      { label: 'Total Ventas', value: totalSales.toLocaleString(), icon: 'fa-shopping-cart', color: '#022040' },
      { label: 'Total Taquillas', value: totalLastIndex.toLocaleString(), icon: 'fa-box', color: '#1e88e5' },
      { label: 'Promedio / Taquilla', value: avgSalesPerLocker, icon: 'fa-chart-line', color: '#43a047' },
      { label: 'Utilización', value: `${utilizationRate}%`, icon: 'fa-percent', color: '#fb8c00' },
      { label: 'Taquillas Activas', value: activeLockers, icon: 'fa-check-circle', color: '#16a34a' },
      { label: 'Taquillas Inactivas', value: idleLockers, icon: 'fa-times-circle', color: '#e53935' },
      { label: 'Top Taquilla', value: topLocker?.Locker || '-', icon: 'fa-trophy', color: '#f59e0b' },
    ];

    return (
      <div className="lqty-totals-grid">
        {stats.map(s => (
          <div key={s.label} className="lqty-totals-stat">
            <div className="lqty-stat-icon" style={{ color: s.color }}>
              <i className={`fas ${s.icon}`} />
            </div>
            <div className="lqty-stat-value">{s.value}</div>
            <div className="lqty-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="lqty-view">
        <div className="lqty-header">
          <div className="lqty-header-content">
            <div className="lqty-header-text">
              <h1>
                <i className="fas fa-box mr-3"></i>
                <span className="text-vw-dark mr-1">Lockers</span>
                <span className="text-vw-light">por Cantidad</span>
              </h1>
            </div>
          </div>
        </div>

        <div className="lqty-filter-card">
          <div className="lqty-filter-header">
            <h3><i className="fas fa-filter"></i> Filtros</h3>
          </div>
          <div className="lqty-filter-body">
            <LockerQtyFilterForm />
          </div>
        </div>

        <div className="lqty-section-card">
          <div className="lqty-section-header">
            <i className="fas fa-chart-bar mr-2"></i>Totales
          </div>
          <div className="lqty-section-body">
            {this.renderTotals()}
          </div>
        </div>

        <div className="lqty-section-card">
          <div className="lqty-section-header">
            <i className="fas fa-list mr-2"></i>Listado
          </div>
          <div className="lqty-section-body p-0">
            {this.renderTable()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  objectives: state.objectives,
  machines: state.machines.machines,
  role: state.auth.role,
  customerId: state.auth.id,
  selectedCustomer: selector(state, 'Customer'),
  selectedMachine: selector(state, 'Machine'),
});

const mapDispatchToProps = dispatch => ({
  fetchLockerQty: bindActionCreators(fetchLockerQty, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerQtyView);
